import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography, Divider } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.webp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Chip from '@mui/material/Chip';
import { useDispatch, useSelector } from "react-redux";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from '@mui/material/OutlinedInput';
// import { fetchCMSData } from "../../../Actions/CmsAction";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";

const accordianData = [
    {
        question: "What is Finowiz ?",
        answer: "Founded in 2016, Finowiz provides a comprehensive trading environment for Contracts for Difference (CFDs), covering FX currency pairs, stock indexes, metals, and energy. Our clients can trade these CFD products using MetaTrader 4, MetaTrader 5, or via Web Trader. As a global retail brokerage, Finowiz is committed to offering top-tier services to traders worldwide.",
        panel: "panel1"
    },
    {
        question: "Is it mandatory to register my card before making a deposit?",
        answer: "Yes, it is. To enable credit card deposits, you must pre-register your card with Shufti, our automated authentication system, available in the Client Cabinet. If automatic authentication is not possible due to the absence of a camera, you can alternatively send a selfie holding your credit card and ID to our support team via email.",
        panel: "panel2"
    },
    {
        question: "I have invalidated/updated the credit cards utilized for deposits. How can I retrieve the funds?",
        answer: "Even if you have invalidated or renewed the credit/debit card used for a deposit, you can still withdraw funds to the original card. This process depends on the information maintained by the card company. However, specific details may vary, so it is advisable to verify with your card company.",
        panel: "panel3"
    },
    {
        question: "I am unable to transfer funds between accounts.",
        answer: "Fund transfers might be restricted if you have ongoing positions, especially if the transfer amount is equal to or exceeds 90% of your effective margin. Please review the transfer amount and try again",
        panel: "panel4"
    },
    {
        question: "Can I utilize my demo account indefinitely?",
        answer: "Clients with a live account can maintain up to 3 demo accounts without an expiration date. If you wish to set up a demo account with no defined expiry, please contact us with your specific details.",
        panel: "panel5"
    },
    {
        question: "I am encountering difficulties depositing with a credit (debit) card.",
        answer: "Several factors could be causing this issue, such as limitations related to the card type, input errors, browser compatibility, or restrictions set by the card company. Please check your card's status and, if needed, contact your card company to resolve any restrictions.",
        panel: "panel6"
    }
    ,
    {
        question: "Will there be a fee for credit card withdrawals?",
        answer: "No, there are no fees for deposits or withdrawals made with a credit or debit card. For details on fees associated with alternative withdrawal methods, please refer to the provided information",
        panel: "panel7"
    }
    ,
    {
        question: "How does debit card withdrawal differ from credit card refund processing?",
        answer: "While refund procedures are similar for credit and debit cards, there are key differences. Debit card transactions result in immediate deductions from your account. Refunds to debit cards are directly credited back to your bank account.",
        panel: "panel8"
    }
    ,
    {
        question: "Introducing Broker (IB) Program",
        answer: "If you're interested in joining our Introducing Broker (IB) program, please complete our form. For any inquiries about the IB program, contact our partner team at support@finowiz.com.",
        panel: "panel9"
    }
    ,

]

const AccoditionDetail = () => {
    return (<table style={{ width: "100%", color: "#fff" }}>
        <tr >
            <td align="left" style={{ width: "400px" }}>00:30</td>
            <td align="left" style={{ width: "400px" }}>AUD</td>
            <td align="left" >Australia_Employment AU_HMR1</td>
        </tr>
        <tr>
            <td align="left">01:00</td>
            <td align="left">GBP</td>
            <td align="left">Australia_Employment_indices</td>
        </tr>
        <tr>
            <td align="left">00:30</td>
            <td align="left">GBP</td>
            <td align="left">United Kingdom_Claimant Count Rate_indices</td>
        </tr>
        <tr>
            <td align="left">07:00</td>
            <td align="left">XAL</td>
            <td align="left">China_SHFE Aluminium On Warrant Change</td>
        </tr>
    </table>);


}
// const AccoditionDetail2 = () => {
//     return (
//         <div style={{ overflow: "scroll" }}>
//             <div className="display-1 p-10" style={{ gap: 15 }} >
//                 <p>07:00</p>
//                 <p>XAL</p>
//                 <p>Australia_Employment AU_HMR1</p>
//             </div>
//             <div className="display-1 p-10" style={{ gap: 15 }}>
//                 <p>01:00</p>
//                 <p>XAL</p>
//                 <p>Australia_Employment_indices</p>
//             </div>
//             <div className="display-1 p-10" style={{ gap: 15 }}>
//                 <p>00:30</p>
//                 <p>GBP</p>
//                 <p>United Kingdom_Claimant Count Rate_indices</p>
//             </div>
//             <div className="display-1 p-10" style={{ gap: 15 }}>
//                 <p>07:00</p>
//                 <p>XAL</p>
//                 <p>China_SHFE Aluminium On Warrant Change</p>
//             </div>
//         </div>
//     )
// }

// Deposit1
const ITEM_HEIGHTDeposit1 = 40;
const ITEM_PADDING_TOPDeposit1 = 8;
const MenuPropsDeposit1 = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHTDeposit1 * 8.5 + ITEM_PADDING_TOPDeposit1,

        },
    },
};
const namesDeposit1 = [
    'AUD',
    'CNY',
    'GBP',
    'XAL',
    'XCU',
    'XZN',
    'XZN',
    'XZN',
    'XZN',
    'XZN',
    'XZN',
    'XZN',
    'XZN',
];
function getStylesDeposit1(nameDeposit1, personNameDeposit1, themeDeposit1) {
    return {
        fontWeight: personNameDeposit1.includes(nameDeposit1)
            ? themeDeposit1.typography.fontWeightMedium
            : themeDeposit1.typography.fontWeightRegular,
    };
}
const TradingTools = () => {
    // const theme = useTheme();
    // const matches = useMediaQuery(theme.breakpoints.up("md"));
    // const lg = useMediaQuery(theme.breakpoints.up("lg"));
    // const md900 = useMediaQuery(theme.breakpoints.up("900"));
    // const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const [age, setAge] = useState('');

    const handleChangeselect = (event) => {
        setAge(event.target.value);
    };

    const dispatch = useDispatch();
    // const { cmsData, error } = useSelector((state) => state.cms);
    // const cmsData = useSelector(state => state.cms?.["ECONOMICCALENDAR"] || {});
    // const cmsContent = cmsData.content;

    // useEffect(() => {
    //     dispatch(fetchCMSData("ECONOMICCALENDAR"));
    // }, []);
    const theme = useTheme();


    const sm = useMediaQuery(theme.breakpoints.up("sm"));
    const md = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const [country, setCountry] = useState("Select the Country");
    const [deletechip, setdeletechip] = useState(false);

    const navigate = useNavigate();
    //accordion1
    const [expanded1, setExpanded1] = useState(false);

    const handleChange1 = (panel) => (event, isExpanded) => {
        setExpanded1(isExpanded ? panel : false);
    };
    //accordion2
    const [expanded2, setExpanded2] = useState('panel1');

    const handleChange2 = (panel) => (event, isExpanded) => {
        setExpanded2(isExpanded ? panel : false);
    };

    const [value, setValue] = useState(0);

    const handleChangetab = (event, newValue) => {
        setValue(newValue);
    };

    // Deposit1
    const themeDeposit1 = useTheme();
    const [personNameDeposit1, setPersonNameDeposit1] = useState([]);
    const handleChangeDeposit1 = (event) => {
        const {
            target: { value },
        } = event;
        setPersonNameDeposit1(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const [chips, setChips] = useState([
        { id: 1, label: 'AUD' },
        { id: 2, label: 'AUD' },
        { id: 3, label: 'AUD' },
        { id: 4, label: 'Clear All' },
    ]);

    const handleDelete = (chipToDelete) => {
        if (chipToDelete.label === 'Clear All') {
            setChips([]); // Clear all chips
        } else {
            setChips((chips) => chips.filter((chip) => chip.id !== chipToDelete.id));
        }
    }
    return (
        <div className="Outterpage">
            <Header />
            <div className="bg-outer">
                <section className="banner">
                    <div className="contain-width">
                        <div className="calender mt-30 mb-30 text-center">
                            <h1
                            style={{margin: '0 auto'}}
                            >Powerful <span> Trading Tools </span> are on the way!</h1>
                            <p className="mt-20"
                            style={{maxWidth: '900px',margin: '0 auto'}}
                            >We're building smart, intuitive features to supercharge your trading journey. Stay tuned—something game-changing is coming soon!</p>
                        </div>
                    </div>
                </section>
            </div>
            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>


            <Footer />
        </div>
    );
};

export default TradingTools;
